import { Horse } from './types';
import { fetchHorseList } from './api';

/**
 * Fetch horses from MySQL database
 * Returns array of horses and the next ID to use
 */
export async function loadHorsesData(): Promise<{ horses: Horse[], nextId: number }> {
  const data = await fetchHorseList();

  const horses: Horse[] = Object.values(data.ponys).map((pony: any) => ({
    id: pony.id,
    name: pony.name,
    boxNumber: pony.boxNumber,
    owner: pony.owner,
    phone: pony.phone,
    weight: parseFloat(pony.weight) || 0,
    hidden: pony.hidden || false,
    early: pony.early,
    late: pony.late,
    bricks: pony.bricks,
    contractDate: pony.contractDate,
    deceased: pony.deceased || false,
    deceased_date: pony.deceased_date,
    absent: pony.absent || false,
    absent_reason: pony.absent_reason,
    absent_until: pony.absent_until,
    contract: pony.contract ? {
      id: pony.contract.id,
      horse_id: pony.contract.horse_id,
      owner_name: pony.contract.owner_name,
      owner_street: pony.contract.owner_street,
      owner_city: pony.contract.owner_city,
      owner_phone: pony.contract.owner_phone,
      box_rent: parseFloat(pony.contract.box_rent) || 0,
      rent_surcharge: parseFloat(pony.contract.rent_surcharge) || 0,
      contract_date: pony.contract.contract_date,
      start_date: pony.contract.start_date,
      end_date: pony.contract.end_date,
      indefinite: pony.contract.indefinite,
      large_box: pony.contract.large_box,
      hidden: pony.contract.hidden,
      active: pony.contract.active,
      created_at: pony.contract.created_at,
      updated_at: pony.contract.updated_at
    } : undefined
  }));

  return {
    horses,
    nextId: data.ponyNextID
  };
}

// Fallback empty array for backwards compatibility
const horsesData: Horse[] = [];
export default horsesData;
